export const bmw = {
  siteName: "bmw",
  senderName: "BMW",
  logo: "/static/warbox_logo.png",
  name: "BMW",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "bmw-group",
};
